interface SlidePerPage {
  largeDesktop: number;
  desktop: number;
  smallDesktop: number;
  tablet: number;
  mobile: number;
}

export const setPaginationSlide = (slideLayout: string): SlidePerPage => {
  let slidesPerPage: SlidePerPage;
  switch (slideLayout) {
    case 'widescreen':
      slidesPerPage = {
        largeDesktop: 1,
        desktop: 1,
        smallDesktop: 1,
        tablet: 1,
        mobile: 1,
      };
      break;
    case 'medium':
      slidesPerPage = {
        largeDesktop: 2,
        desktop: 2,
        smallDesktop: 1,
        tablet: 1,
        mobile: 1,
      };
      break;

    default:
      slidesPerPage = {
        largeDesktop: 3,
        desktop: 3,
        smallDesktop: 2,
        tablet: 2,
        mobile: 1,
      };
      break;
  }

  return slidesPerPage;
};
